import styled, { css } from 'styled-components';
import { colors, colorAliases } from '../../../variables/colors.js';
import { deviceWidths } from '../../../variables/widths.js';
import { transitions } from '../../../variables/transitions.js';

var PopUp = styled.div.withConfig({
  displayName: "popUp__PopUp",
  componentId: "sc-2wdq0e-0"
})(["background-color:", ";display:flex;flex-direction:column;margin:0;height:100vh;max-height:100%;position:relative;transition:right ", ",left ", ";width:100vw;", " ", " .sg-popup-cancel-icon-bottom{align-self:flex-start;box-sizing:border-box;cursor:pointer;fill:", ";margin:15px 0 30px calc(100% - 30px - 18px);width:18px;height:18px;}", " ", " ", " ", " ", ""], colors.white, transitions["default"], transitions["default"], function (props) {
  return props.roundedTop && css(["border-top-left-radius:30px;border-top-right-radius:30px;"]);
}, function (props) {
  return !props.tablet && css(["@media (min-width:", "){margin:80px auto;height:unset;max-width:", ";min-height:100px;}"], deviceWidths.tablet, deviceWidths.xLargeMobile);
}, colors.darkGray, function (props) {
  return props.size === 'large' && css(["@media (min-width:", "){max-width:900px;}"], deviceWidths.tablet);
}, function (props) {
  return props.mobile && css(["left:0;-webkit-overflow-scrolling:touch;overflow-y:auto;position:fixed;top:0;z-index:10000;@media (min-width:", "){box-shadow:0 0 1px ", ";height:auto;margin:2% 0 0;max-width:975px;position:relative;width:auto;}"], deviceWidths.tablet, colorAliases.shadow);
}, function (props) {
  return props.mobile && props.closed && css(["display:none;"]);
}, function (props) {
  return props.tablet && css(["left:0;-webkit-overflow-scrolling:touch;overflow-y:auto;position:fixed;top:0;z-index:10000;@media (min-width:", "){box-shadow:0 0 1px ", ";height:auto;min-height:100px;margin:0;max-width:975px;position:relative;width:100%;}"], deviceWidths.desktop, colorAliases.shadow);
}, function (props) {
  return props.tablet && props.closed && css(["display:none;"]);
});

export { PopUp };
//# sourceMappingURL=popUp.js.map
